import React from 'react';
import { Phone, Mail, MapPin, Clock } from 'lucide-react';
import LeadCaptureForm from '../components/forms/LeadCaptureForm';
import { COMPANY_INFO, LOGO_URL } from '../data/mockData';

const ContactPage = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Hero */}
      <div className="bg-gradient-to-r from-gray-900 to-gray-800 text-white py-16">
        <div className="max-w-7xl mx-auto px-4 text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">Get In Touch</h1>
          <p className="text-gray-300 text-lg max-w-2xl mx-auto">
            Ready to buy, sell, or just have questions? I'm here to help you every step of the way.
          </p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 py-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          {/* Contact Info */}
          <div>
            <div className="flex items-center gap-4 mb-8">
              <span className="relative h-20 w-20 flex-shrink-0 rounded-full overflow-hidden bg-black ring-1 ring-black/10">
                <img
                  src={LOGO_URL}
                  alt="Brantford Area Homes"
                  className="absolute inset-0 h-full w-full object-cover scale-[1.6]"
                />
              </span>
              <div>
                <h2 className="text-2xl font-bold text-gray-900">Brantford Area Homes</h2>
                <p className="text-gray-600">Alexander Conti · REALTOR® | {COMPANY_INFO.brokerage}</p>
              </div>
            </div>

            <div className="space-y-6">
              <div className="flex items-start gap-4">
                <div className="p-3 bg-red-100 rounded-full">
                  <Phone className="text-red-600" size={24} />
                </div>
                <div>
                  <h3 className="font-semibold text-gray-900">Phone</h3>
                  <a href={`tel:${COMPANY_INFO.phone}`} className="text-gray-600 hover:text-red-600 transition-colors">
                    {COMPANY_INFO.phone}
                  </a>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="p-3 bg-red-100 rounded-full">
                  <Mail className="text-red-600" size={24} />
                </div>
                <div>
                  <h3 className="font-semibold text-gray-900">Email</h3>
                  <p className="text-gray-600 select-all [overflow-wrap:anywhere]">
                    {COMPANY_INFO.email}
                  </p>
                  <p className="text-xs text-gray-400 mt-0.5">Or use the form on the right →</p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="p-3 bg-red-100 rounded-full">
                  <MapPin className="text-red-600" size={24} />
                </div>
                <div>
                  <h3 className="font-semibold text-gray-900">Office</h3>
                  <p className="text-gray-600">{COMPANY_INFO.address}</p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="p-3 bg-red-100 rounded-full">
                  <Clock className="text-red-600" size={24} />
                </div>
                <div>
                  <h3 className="font-semibold text-gray-900">Office Hours</h3>
                  <p className="text-gray-600">Monday - Friday: 9:00 AM - 6:00 PM</p>
                  <p className="text-gray-600">Saturday: 10:00 AM - 4:00 PM</p>
                  <p className="text-gray-600">Sunday: By Appointment</p>
                </div>
              </div>
            </div>

            {/* Map Placeholder */}
            <div className="mt-8 h-64 bg-gray-200 rounded-lg overflow-hidden">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2909.0537851068747!2d-80.26631492346716!3d43.13926707113561!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x882c67d5f5f5f5f5%3A0x5f5f5f5f5f5f5f5f!2s46%20Charing%20Cross%20St%2C%20Brantford%2C%20ON%20N3R%202H3!5e0!3m2!1sen!2sca!4v1620000000000!5m2!1sen!2sca"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                title="Office Location"
              />
            </div>
          </div>

          {/* Contact Form */}
          <div>
            <LeadCaptureForm 
              variant="full" 
              title="Send Me a Message" 
              subtitle="I'll get back to you within 24 hours"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactPage;
